<nz-affix [nzOffsetTop]="0" *transloco="let tr; prefix: 'cities'; scope: 'cities'">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
    <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
    <nz-page-header-extra>
      <a routerLink="new" nz-button nzType="primary">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
      </a>
    </nz-page-header-extra>
    <nz-page-header-footer>
      <hc-cities-tabs></hc-cities-tabs>
    </nz-page-header-footer>
  </nz-page-header>
</nz-affix>

<nz-collapse nzBordered="false">
  <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
    <div nz-row [nzGutter]="[16,24]">
      <div nz-col>
        <hx-country-select [(ngModel)]="filter.countryId" (ngModelChange)="applyFilters()"></hx-country-select>
      </div>
    </div>
  </nz-collapse-panel>
</nz-collapse>

<nz-table [nzLoading]="isTableLoading" *transloco="let tr; prefix: 'cities'; scope: 'cities'"
          [nzTotal]="total"
          [nzPageSize]="limit"
          [nzPageIndex]="page"
          [nzData]="list"
          (nzQueryParams)="onQueryParamsChange($event)"
          [nzFrontPagination]="false">
  <thead>
  <tr>
    <th nzColumnKey="title" [nzSortOrder]="columnSortOrderMap.get('title') || null" [nzSortFn]="true"
        [nzSortPriority]="1">{{tr('column.title')}}</th>
    <th>{{tr('column.country')}}</th>
    <th>{{tr('column.order')}}</th>
    <th nzWidth="100px">#</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let data of list">
    <td>
      <i nz-icon [nzType]="data.enabled ? 'check-circle': 'minus-circle'" [nzTwotoneColor]="data.enabled ? '#52c41a' : '#ff4d4f'" nzTheme="twotone"></i>
      {{ data.title | uiLabel }}
    </td>
    <td><strong>{{data.country.title | uiLabel}}</strong></td>
    <td>
      {{data.order}}
    </td>
    <td>
      <nz-button-group>
        <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
          <i nz-icon nzType="edit" nzTheme="outline"></i>
        </a>
        <a [routerLink]="data.id + '/properties'" nz-button nzType="primary">
          <i nz-icon nzType="setting" nzTheme="outline"></i>
        </a>
        <button nz-button nzType="default" nzDanger nz-popconfirm
                [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                [nzCancelText]="'no1' | transloco"
                (nzOnConfirm)="remove(data.id)">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </button>
      </nz-button-group>
    </td>
  </tr>
  </tbody>
</nz-table>
